import { Box, TableCell, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";

export const TableContainerWrapper = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.colors.neutral.lightGray}`,
  borderRadius: theme.spacing(1),
  overflow: "scroll",
  marginBottom: theme.spacing(5)
}));

interface HeaderCellProps {
  sortable?: boolean;
}

export const HeaderCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "sortable",
})<HeaderCellProps>(({ theme, sortable }) => ({
  backgroundColor: theme.colors.neutral.white,
  fontWeight: 600,
  color: theme.colors.neutral.darkGray,
  cursor: sortable ? "pointer" : "default",
  userSelect: "none",
  transition: theme.transitions.create("background-color", {
    duration: theme.transitions.duration.shorter,
  }),
  borderBottom: `1px solid ${theme.colors.neutral.lightGray}`,
  ...(sortable && {
    "&:hover": {
      backgroundColor: theme.colors.neutral.softGray,
    },
  }),
  padding: theme.spacing(2),
  position: "sticky",
  top: 0,
  zIndex: 1,
}))

export const HeaderCellContent = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  justifyContent: "flex-start",
  whiteSpace: "nowrap",
}));

export const SortIcon = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "16px",
  height: "16px",
  color: theme.colors.primary.slalomBlue,
  fontSize: "14px",
  flexShrink: 0,
}));

interface BodyRowProps {
  isClickable?: boolean;
}

export const BodyRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== "isClickable",
})<BodyRowProps>(({ theme, isClickable }) => ({
  cursor: isClickable ? "pointer" : "default",
  transition: theme.transitions.create("background-color", {
    duration: theme.transitions.duration.shorter,
  }),
  borderBottom: `1px solid ${theme.colors.neutral.lightGray}`,
  "&:hover": isClickable
    ? {
        backgroundColor: theme.colors.neutral.softGray,
      }
    : {},
  "&:last-child": {
    borderBottom: "none",
  },
}));

export const BodyCellContent = styled(Box)(({ theme }) => ({
  color: theme.colors.neutral.black,
  fontSize: "0.875rem",
  lineHeight: "1.5",
  padding: "0",
}));
